var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "175mm",
    height: "115mm",
    viewBox: "0 0 175 115",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#370E00",
      strokeWidth: 0.239317
    },
    id: "rect1",
    width: 25.066496,
    height: 105.07674,
    x: 5.0031338,
    y: 4.912858
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#370E00",
      strokeWidth: 0.239317
    },
    id: "rect1-2",
    width: 25.066496,
    height: 105.07674,
    x: 84.01638,
    y: 4.9251614
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1-7-2",
    style: {
      display: "inline",
      fill: "#370E00",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.44109,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 33.392954,7.3737606 V 57.059179 h 3.059732 a 20.639983,46.624038 0 0 1 -0.0078,-0.27242 20.639983,46.624038 0 0 1 20.639869,-46.624405 20.639983,46.624038 0 0 1 20.640383,46.624405 20.639983,46.624038 0 0 1 -0.008,0.27242 h 2.85897 V 7.3737606 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#370E00",
      strokeWidth: 0.239317
    },
    id: "rect1-2-5",
    width: 25.066496,
    height: 105.07674,
    x: 103.61279,
    y: 40.905636,
    transform: "rotate(-16.716494)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "none",
      stroke: "#370E00",
      strokeWidth: 4.42193,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect1-7",
    width: 45.647125,
    height: 100.59087,
    x: 34.218742,
    y: 7.2017794
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.349d2e4866fe6c66a73a9a946406cb08.svg";
export { ForwardRef as ReactComponent };